import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 4B7477D9-418A-40E7-811A-50DFFEA14A03
 * name check-underline-circle
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-underline-circle.svg
 * tags
 */
export const CheckUnderlineCircleIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M17,18H7V16H17V18M10.3,14L7,10.7L8.4,9.3L10.3,11.2L15.6,5.9L17,7.3L10.3,14Z" /></>, 'CheckUnderlineCircleIcon');
export default CheckUnderlineCircleIcon